import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface SwipeSlideProps {
  bg: string;
  content: ReactNode;
  onSwipeLeft: () => void;
  onSwipeRight: () => void;
}

export default function SwipeSlide({
  bg,
  content,
  onSwipeLeft,
  onSwipeRight,
}: SwipeSlideProps) {
  return (
    <motion.div
      className="full-page"
      style={{ backgroundColor: bg }}
      initial={{ x: 1000, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -1000, opacity: 0 }}
      transition={{ duration: 0.6 }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      onDragEnd={(e, { offset }) => {
        if (offset.x < -100) onSwipeLeft();
        else if (offset.x > 100) onSwipeRight();
      }}
    >
      <div className="slide-content">{content}</div>
    </motion.div>
  );
}
